<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="card border border-radius-12">
                    <div class="card-body table mb-0">
                        <div class="row justify-content-between">
                            <div class="col-xl-8 col-12">
                                <div
                                    class="d-flex align-items-sm-center align-items-start gap-lg-3 gap-2 flex-column flex-sm-row">
                                    <PageHeader title="Discount Coupons" :items="items"
                                        class="poppins fw-normal ps-3 text-nowrap" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <coupanList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "@/views/layouts/static/main";
import PageHeader from "@/components/static/page-header";
import coupanList from "@/components/general/coupanList.vue";
export default {
    name: "CoupanList",
    components: {
        Layout,
        PageHeader,
        coupanList,
    },
}
</script>
